if (!customElements.get('adev-new-product')) {
    customElements.define('adev-new-product', class adevNewProduct extends HTMLElement {
        constructor() {
            super();

            this.variantsData = JSON.parse(this.querySelector('[data-adev-product="variants-json"]').innerHTML);

            this.setCurrentVariant();

            this.form = this.querySelector('[data-adev-product="form"]');
            this.addToCartEl = this.querySelector('[data-adev-product="add-to-cart"]');

            this.form.addEventListener('submit', this.handleSubmit.bind(this));

            this.initVariantsPicker();
        }

        formatMoney(t,e){
            function n(t,e){return void 0===t?e:t}function o(t,e,o,i){if(e=n(e,2),o=n(o,","),i=n(i,"."),isNaN(t)||null==t)return 0;var r=(t=(t/100).toFixed(e)).split(".");return r[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,"$1"+o)+(r[1]?i+r[1]:"")}"string"==typeof t&&(t=t.replace(".",""));var i="",r=/\{\{\s*(\w+)\s*\}\}/,a=e||window.adev_theme.moneyFormat;switch(a.match(r)[1]){case"amount":i=o(t,2);break;case"amount_no_decimals":i=o(t,0);break;case"amount_with_comma_separator":i=o(t,2,".",",");break;case"amount_with_space_separator":i=o(t,2," ",",");break;case"amount_with_period_and_space_separator":i=o(t,2," ",".");break;case"amount_no_decimals_with_comma_separator":i=o(t,0,".",",");break;case"amount_no_decimals_with_space_separator":i=o(t,0," ");break;case"amount_with_apostrophe_separator":i=o(t,2,"'",".")}return a.replace(r,i)
        }

        initVariantsPicker(){
            this.querySelectorAll('[data-adev-product="variant-picker-option"]').forEach(option => {

                this.querySelectorAll('[data-adev-product="variant-picker-option-value"]').forEach(input => {
                    input.addEventListener('change', () => {
                        this.refresh();
                    })
                });

            });
        }

        setCurrentVariant(){
            this.variantOptions = Array.from(this.querySelectorAll('[data-adev-product="variant-picker-option-value"]:checked')).map(input => {
                return input.value;
            });

            this.currentVariant = this.variantsData.find((variant) => {
                return !variant.options.map((option, index) => {
                    return this.variantOptions[index] === option
                })
                .includes(false);
            });

            const currentVariantEl = this.querySelector('[data-adev-product="current-variant-id"]');
            if (currentVariantEl) {
                currentVariantEl.value = this.currentVariant.id;
                currentVariantEl.dispatchEvent(new Event('change', { bubbles: true }));
            }
        }

        updatePrice(){
            this.querySelectorAll('[data-adev-product="current-price"]').forEach(priceElement => {
                priceElement.innerText = this.formatMoney(this.currentVariant.price);
            });

            this.querySelectorAll('[data-adev-product="regular-price"]').forEach(priceElement => {
                if (this.currentVariant.compare_at_price > this.currentVariant.price) {
                    priceElement.innerText = this.formatMoney(this.currentVariant.compare_at_price);
                } else {
                    priceElement.innerText = '';
                }
            });
        }

        updateVariantStatuses(){
            const selectedOptionOneVariants = this.variantsData.filter(variant => {
                const firstCheckedInput = this.querySelector('[data-adev-product="variant-picker-option-value"]:checked');
				return firstCheckedInput && firstCheckedInput.value === variant.option1
			});

			const options = this.querySelectorAll('[data-adev-product="variant-picker-option"]')
			options.forEach((option, index) => {
				if(index === 0) {
					return;
				}

				const previousOptionSelected = options[index - 1].querySelector(':checked').value;

				const availableOptionInputsValue = selectedOptionOneVariants
					.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected)
					.map(variant => variant[`option${ index + 1 }`]);

				const optionInputs = option.querySelectorAll('[data-adev-product="variant-picker-option-value"]');

				optionInputs.forEach(input => {
					if (availableOptionInputsValue.includes(input.getAttribute('value'))) {
						input.classList.remove('disabled');
					} else {
						input.classList.add('disabled');
					}
				});

			});
        }

        updateAddToCart(){
            this.addToCartEl.disabled = !this.currentVariant.available;
            const textEl = this.addToCartEl.querySelector('[data-adev-product="add-to-cart-text"]');

            const availableText = textEl.dataset.available;
            const soldOutText = textEl.dataset.soldOut;

            if (this.currentVariant.available) {
                textEl.innerText = availableText.replace('[amount]', this.formatMoney(this.currentVariant.price));
            } else {
                textEl.innerText = soldOutText;
            }
        }

        setUrlHistory(){
            const url = new URL(window.location);
            url.searchParams.set('variant', this.currentVariant.id);
            window.history.replaceState({}, '', url);
        }

        refresh(){
            this.setCurrentVariant();
            this.updatePrice();
            this.updateVariantStatuses();
            this.updateAddToCart();
            this.setUrlHistory();
        }

        handleSubmit(e) {
            e.preventDefault();

            this.addToCartEl.classList.add('loading');

            const formData = new FormData(this.form);
            formData.append('sections', 'cart-count,cart-drawer');
            formData.append('sections_url', window.location.pathname);

            fetch(adev_theme.routes.cartAddUrl, {
                method: 'POST',
                body: formData,
            })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(data => {
                this.refreshCart(data);
                this.addToCartEl.classList.remove('loading');
            })
            .catch(error => {
                console.error('There was a problem with the fetch operation:', error);
                this.addToCartEl.classList.remove('loading');
            });

        }

        refreshCart(cart){
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer) {
                cartDrawer.renderContents(cart);

                if (cartDrawer.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');
            }
        }

    });
}